import Vue from 'vue'
import Router from 'vue-router'

import { apiIsUserAdmin, apiGetCurrentUser } from '@/services/firebase'

import store from '@/store.js'

Vue.use(Router)

console.log('::: [DEBUG] BASE_URL:', process?.env?.BASE_URL || '[ERROR]')

const myRouter = new Router({
  mode: 'history',
  base: process?.env?.BASE_URL || '/',
  routes: [
    //
    // PÁGINA DE LOGIN
    //

    {
      name: 'Login',
      path: '/login',
      component: () => import('@/sosgestor/pages/public/Login'),
    },

    //
    //
    //

    {
      path: '/',
      component: () => import('@/sosgestor/pages/general/layout'),
      children: [
        //
        //
        //

        {
          redirect: '/login',
          path: '',
        },
      ],
    },

    //
    //
    //

    {
      path: '/admin',
      component: () => import('@/sosgestor/pages/logged/layout'),
      children: [
        //
        // LISTA DE GRUPOS
        //

        {
          name: 'Grupos',
          path: 'grupos',
          component: () => import('@/sosgestor/pages/logged/GroupsList'),
          meta: {
            requiresAuth: true,
          },
        },

        //
        // PERFIL
        //

        {
          name: 'Minha Conta',
          path: 'perfil',
          component: () => import('@/sosgestor/pages/logged/Profile'),
          meta: {
            requiresAuth: true,
          },
        },

        //
        //
        //
        // TELAS DENTRO DE UM GRUPO
        //
        //
        //

        //
        // GRUPO
        //

        {
          name: 'Escalas',
          path: 'grupos/:groupID/escalas',
          component: () => import('@/sosgestor/pages/logged/Group'),
          meta: {
            requiresAuth: true,
            requiresGroupPrivilege: true,
          },
        },

        //
        // VER ESCALA
        //

        {
          name: 'Ver Escala',
          path: 'grupos/:groupID/escalas/:scaleID',
          component: () => import('@/sosgestor/pages/logged/ViewScale'),
          meta: {
            requiresAuth: true,
            requiresGroupPrivilege: true,
          },
        },

        //
        // PLANTÕES DO USUÁRIO
        //

        {
          name: 'Usuário do grupo',
          path: 'grupos/:groupID/usuario/:userID/plantoes',
          component: () => import('@/sosgestor/pages/logged/GroupUserShifts'),
          meta: {
            requiresAuth: true,
            requiresGroupPrivilege: true,
          },
        },

        //
        // AGENDAMENTOS DO GRUPO
        //

        {
          name: 'Agendamentos do grupo',
          path: 'grupos/:groupID/agendamentos',
          component: () => import('@/sosgestor/pages/logged/Agendamentos'),
          meta: {
            requiresAuth: true,
            requiresGroupPrivilege: true,
          },
        },
      ],
    },

    //
    //
    //

    {
      path: '*',
      component: () => import('@/sosgestor/pages/general/layout'),
      children: [
        {
          name: 'Página não encontrada',
          path: '',
          component: () => import('@/sosgestor/pages/general/PageNotFound'),
        },
      ],
    },
  ],
})

myRouter.beforeEach(async (to, from, next) => {
  const firebaseCU = apiGetCurrentUser()
  const stateCU = store.state.userSession

  const loggedIn = stateCU.loggedIn ? stateCU.loggedIn : (!!firebaseCU === true)
  const userID = stateCU.loggedIn ? stateCU.uid : (!!firebaseCU === true && Object.prototype.hasOwnProperty.call(firebaseCU, 'uid') ? firebaseCU.uid : '')

  // [24/01/25] console.log(`::: MOVENDO DA ROTA "${from.path}" PARA "${to.path}":`, userID, loggedIn)

  /* VERIFICA SE É ADMIN */
  const requiresGroupPrivilege = to.matched.some(record => record.meta.requiresGroupPrivilege)
  const groupID = requiresGroupPrivilege ? to.params.groupID : false

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  // console.log('beforeEach[rota]:', from, to)
  // console.log('beforeEach[store]:', store.state.userSession)

  /**
   *
   * O SISTEMA NÃO DEPENDE APENAS DO "onAuthStateChanged" PARA MANTER O VUEX ATUALIZADO COM AO STATUS ATUAL DA SESSÃO
   *
   * [20/01/25] Descoberto nas melhorias da tela de convite.
   *
   * [20/01/25] CENÁRIO DA DESCOBERTA:
   *
   * - Voltei (botão voltar do navegador sem F5) para a tela de convite após um LOGOUT ou LOGIN (que redirecionou a tela de convite para outra tela) e
   *   a tela ficava "CARREGANDO..." e não mudava.
   *
   */

  const authenticated = !!firebaseCU === true && !!firebaseCU.email === true && !!firebaseCU.uid === true

  store.dispatch('setAuthState', {
    sosOrigin: 'ROUTER',
    authenticated,
    uid: authenticated ? firebaseCU.uid : '',
    email: authenticated ? firebaseCU.email : '',
    token: authenticated ? await firebaseCU.getIdToken() : '',
    user: firebaseCU,
  })

  /**
   *
   * TRATA NAVEGAÇÃO PARA A LISTA DE GRUPOS
   *
   */

  if ((from.path !== '/admin/grupos/' && to.path === '/admin/grupos/') || (from.path !== '/admin/grupos' && to.path === '/admin/grupos')) {
    // [24/01/25] console.log('::: ENTROU NA LISTA DE GRUPOS >>> startUserGroupsListeners')
    store.dispatch('startUserGroupsListeners')
  }

  if ((from.path === '/admin/grupos/' && to.path !== '/admin/grupos/') || (from.path === '/admin/grupos' && to.path !== '/admin/grupos')) {
    // [24/01/25] console.log('::: SAIU DA LISTA DE GRUPOS >>> stopUserGroupsListeners')
    store.dispatch('stopUserGroupsListeners')
  }

  /**
   *
   * TRATA AS ROTAS
   *
   */

  if (to.path === '/404' || !requiresAuth)
  {
    // [24/01/25] if (to.path === '/404') console.log('::: MOVENDO PARA A ROTA 404')
    // [24/01/25] if (!requiresAuth) console.log('::: ESSA ROTA NÃO REQUER AUTENTICAÇÃO')

    next()
  }
  else if (!loggedIn && to.path !== '/login')
  {
    // chega aqui se for requiresAuth === true
    // [24/01/25] console.log('::: VOCÊ NÃO ESTÁ LOGADO, MOVENDO PARA A TELA DE LOGIN...')
    next('/login')
  }
  else
  {
    if (requiresGroupPrivilege)
    {
      /* console.log('::: ESSA ROTA REQUER PRIVILÉGIOS DE GESTOR, VERIFICANDO...', userID, groupID) */

      const admin = await apiIsUserAdmin(userID, groupID)

      if (admin) {
        // [24/01/25] console.log('::: ESSA ROTA REQUER PRIVILÉGIOS DE GESTOR: PERMITIDO')
        next()
      } else {
        // [24/01/25] console.log('::: ESSA ROTA REQUER PRIVILÉGIOS DE GESTOR: NÃO PERMITIDO')
        next('/admin/grupos')
      }
    }
    else
    {
      // [24/01/25] console.log('::: MOVENDO PARA A ROTA...')
      next()
    }
  }
})

export default myRouter
